


















import draggable from 'vuedraggable';
import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { SchoolGroupStudent } from '@/models/school-group/school-group-student';
import { GPageBase } from '@/mixins';
import { globalModule } from '@/store/modules/global.module';

@Component({
  name: 'GGroupDraggable',
  components: { draggable },
  computed: {},
  methods: {},
})
export default class GGroupDraggable extends Mixins(GPageBase) {
  options: any = { group: 'drag_list', handle: '.person-item' };
  mounted() {}

  @Prop({ default: (): SchoolGroupStudent[] => [] }) studentGroups: SchoolGroupStudent[];

  get isOldSchoolYear(): boolean {
    return globalModule.isOldSchoolYear;
  }
}
